import React from "react";
import { Box, InputAdornment, IconButton } from "@mui/material";
import { Controller, } from "react-hook-form";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";
import { Calendar2 } from "iconsax-react";
import { useTranslation } from "react-i18next";
export const FDatePicker = ({ name, control, label, error, disabled = false, disablePast, disableFuture, minDate, maxDate, backgroundColor = "transparent", size = "medium", required = false, rules, onChange, }) => {
    const { t } = useTranslation(["form", "validation", "common"]);
    const [open, setOpen] = React.useState(false);
    dayjs.extend(updateLocale);
    dayjs.updateLocale("en", { weekStart: 1 }); // 0 = Sunday, 1 = Monday
    const handleIconClick = () => setOpen(true);
    return (React.createElement(Box, { width: "100%" },
        React.createElement(Controller, { name: name, control: control, rules: rules, render: ({ field }) => (React.createElement(LocalizationProvider, { dateAdapter: AdapterDayjs },
                React.createElement(DatePicker, { sx: {
                        width: "100%",
                        background: backgroundColor,
                    }, open: open, onClose: () => setOpen(false), minDate: minDate, maxDate: maxDate, disabled: disabled, label: React.createElement(React.Fragment, null,
                        t(label),
                        required && React.createElement("span", { style: { color: "red" } }, "\u00A0*")), format: "DD/MM/YYYY", value: field.value ? dayjs(field.value) : null, closeOnSelect: true, onChange: (date) => {
                        let parsedDate = null;
                        if (date && typeof date.toDate === "function") {
                            parsedDate = date.toDate();
                        }
                        else if (date instanceof Date) {
                            parsedDate = date;
                        }
                        else {
                            parsedDate = null;
                        }
                        field.onChange(parsedDate);
                        if (onChange)
                            onChange(parsedDate);
                    }, disablePast: disablePast, disableFuture: disableFuture, enableAccessibleFieldDOMStructure: false, slotProps: {
                        textField: {
                            variant: "filled",
                            fullWidth: true,
                            size,
                            error: !!error,
                            helperText: error === null || error === void 0 ? void 0 : error.message, // ✅ this line fixes the missing message issue
                            onClick: handleIconClick,
                            InputProps: {
                                endAdornment: (React.createElement(InputAdornment, { position: "end" },
                                    React.createElement(IconButton, { edge: "end", size: "small", onClick: handleIconClick, sx: { width: 32, height: 32 } },
                                        React.createElement(Calendar2, { size: 20, color: "#00244D" })))),
                            },
                        },
                    } }))) })));
};
